import { CCol, CRow } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import HeadTools from '../../../purchase/stepsContext/selectNumbers/HeadTools'
import LineList from '../../../purchase/stepsContext/selectNumbers/LineList'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { Line } from '../../../../../service/interfaces/purchase'
import { getProductNumbersCountRequestAction } from '../../../../../service/actions/purchaseActions'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../service/store'

const NumberSelection = () => {

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [states, setStates] = CustomValuesHook({})
    const [selectedNumber, setSelectedNumber] = useState<Line | undefined>()
    const productNumbersCount = useSelector((state: any) => state.purchaseReducer.packageNumbersCount)
    const responseLines = useSelector((state: IRootState) => state.purchaseReducer.resultLines) as [Line]

    const ToInvoiceStep = (number: Line) => {

        navigate("/landingPurchase/step-3" + location.state.urlSearch, { state: { ...location?.state, selectedLine: number } })
    }


    useEffect(() => {

        if (location.state.selectedLine) {
            setSelectedNumber(location.state.selectedLine)
        }
        if (responseLines === null) {
            dispatch(getProductNumbersCountRequestAction({ productId: location?.state?.productId || "" }))

        }

    }, [])


    return (
        <div className='numbers-step-context content-container'>
            <h3>انتخاب شماره</h3>
            در این مرحله می توانید <b>
                ۱
                {/* {productNumbersCount ? productNumbersCount : 0} */}
            </b> شماره برای کسب و کار خود انتخاب نمایید تا سرویس شما روی آن فعال گردد.

            <HeadTools selectedNumber={selectedNumber} states={states} setStates={setStates} externalPurchase={true}
                prefixNumberList={states.prefixNumberList} isSPLBuyPage={false} />
            <div style={{}} >
                <CRow>
                    <CCol lg={2} md={0} sm={0}></CCol>
                    <CCol lg={8} md={12} sm={12} className='number-main-list-container'>
                        {/* <div className='loading-context' ><CSpinner color="default" /></div> */}

                        <LineList
                            selectANumber={ToInvoiceStep}
                            selectedNumber={selectedNumber}
                            setSelectedNumber={setSelectedNumber}
                            states={states} />
                    </CCol>

                </CRow>
            </div>

            <div className='d-flex justify-content-between btn-container'>
                <button onClick={() => navigate("/landingPurchase/step-1" + location.state.urlSearch, { state: { ...location?.state } })} className='btn btn-info' >مرحله قبل</button>

                <button disabled={!selectedNumber} onClick={() =>
                    navigate(`/landingPurchase/step-3/${location?.state?.productType}/${location?.state?.productId}/${location?.state?.contractTypeId}${location.state.urlSearch}`
                        , { state: { ...location?.state, selectedLine: selectedNumber } })
                } className='btn btn-info' >مرحله بعد</button>

            </div>

        </div>
    )

}

export default NumberSelection